import { useQuery } from '@tanstack/react-query';
import type { IStateTaxClassification } from '~/models/StateTaxClassification';
import { getOfficeWorkerClassification } from '../clients/GetOfficeWorkerClassification';
import { locationSettingsKeys } from './locationSettingsKeys';

interface IUseOfficeWorkerClassificationOptions {
  /** Off for the selected office, whose rule redux already holds. */
  enabled: boolean;
}

/** The worker models one location's state allows, cached per location. */
export const useOfficeWorkerClassification = (
  officeId: string | undefined,
  { enabled }: IUseOfficeWorkerClassificationOptions,
) =>
  useQuery<IStateTaxClassification>({
    queryKey: locationSettingsKeys.workerClassification(officeId ?? ''),
    queryFn: () => getOfficeWorkerClassification(officeId as string),
    enabled: enabled && !!officeId,
  });
